module.exports = __webpack_public_path__ + "static/img/meetingroom.652e348.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meetingroom.jpg
// module id = 572
// module chunks = 1